import { Card } from 'antd';

import { ErrorFallback, type WidgetErrorProps } from '@/shared/ui/ErrorBoundary';
import { LoadingState } from '@/shared/ui/states/LoadingState';

import { useGpuPowerUsage } from '@/features/monitoring/model';
import { GpuPowerGauge } from '@/features/monitoring/ui/GpuPowerGauge';

import { getGpuGaugeHeight } from '@/widgets/monitoring/shared';

import styles from './GpuPowerMetric.module.css';

type GpuPowerMetricProps = {
  selectedWorker: string;
};

const Content = ({ selectedWorker }: GpuPowerMetricProps) => {
  const shouldFetch = !!selectedWorker;
  const { data: gpuPowers, isLoading } = useGpuPowerUsage(selectedWorker || '', shouldFetch);

  const chartHeight = getGpuGaugeHeight(gpuPowers?.length || 4);

  if (!selectedWorker) {
    return (
      <Card title="GPU Power Total" className={styles.card}>
        <div className={styles.noData}>Worker를 선택해주세요</div>
      </Card>
    );
  }

  return (
    <Card title="GPU Power Total" className={styles.card}>
      {isLoading ? (
        <LoadingState message="GPU 전력 로딩 중..." compact />
      ) : (
        <div
          className={styles.gaugeGrid}
          key={selectedWorker}
          style={{
            gridTemplateColumns: `repeat(${Math.min(gpuPowers?.length || 1, 4)}, 1fr)`,
          }}>
          {gpuPowers && gpuPowers.length > 0 ? (
            gpuPowers.map((gpu) => (
              <GpuPowerGauge key={`${selectedWorker}-${gpu.gpu}-${gpu.device}`} data={gpu} height={chartHeight} />
            ))
          ) : (
            <div className={styles.noData}>선택한 Worker에 GPU 전력 데이터가 없습니다.</div>
          )}
        </div>
      )}
    </Card>
  );
};

const Error = ({ title, description, ...props }: WidgetErrorProps) => {
  return (
    <Card title="GPU Power Total" className={styles.card}>
      <ErrorFallback title={title} description={description} {...props} />
    </Card>
  );
};

export const GpuPowerMetric = { Content, Error };
